/** Shared reading remains available before install, plan and salary setup. */
export function isLinkedReadingRoute(pathname: string): boolean {
  return pathname === "/splits" || /^\/splits\/linked\/[^/]+$/.test(pathname);
}
